import React from 'react'
import {Box, Typography, useTheme} from '@mui/material'
import {useAppSelector} from 'src/hooks'

interface BrandHeaderProps {
  expanded: boolean
}

const BrandHeader = ({expanded}: BrandHeaderProps): JSX.Element => {
  const theme = useTheme()
  const pspLogo = useAppSelector(state => state.pspConfigReducer.data.logoPSP ?? '')
  const pspTitle = useAppSelector(state => state.pspConfigReducer.data.PSPTitleAndIcon?.title ?? '')

  const initials = pspTitle
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w: string) => w[0]?.toUpperCase() ?? '')
    .join('')

  const avatar = pspLogo ? (
    <Box
      component="img"
      src={`data:image/png;base64,${pspLogo}`}
      alt={pspTitle}
      sx={{
        width: 40,
        height: 40,
        objectFit: 'contain',
        borderRadius: '50%',
        flexShrink: 0,
      }}
    />
  ) : (
    <Box
      sx={{
        width: 40,
        height: 40,
        borderRadius: '50%',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 16,
        fontWeight: 700,
        flexShrink: 0,
      }}
    >
      {initials || '?'}
    </Box>
  )

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: expanded ? 1.5 : 0,
        px: expanded ? 3 : 1,
        pt: 3,
        pb: 2,
        justifyContent: expanded ? 'flex-start' : 'center',
        minHeight: 92,
      }}
    >
      {avatar}
      {expanded && (
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 600,
            lineHeight: 1.2,
            color: 'text.primary',
            minWidth: 0,
          }}
        >
          {pspTitle || 'PSP'}
        </Typography>
      )}
    </Box>
  )
}

export default BrandHeader
